<section class="section-container">
  <button
    class="left-button"
    mat-fab
    aria-label="Previous"
    (click)="scrollLeft()"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>
  <div class="carrousel-container" #carrouselContainer>
  
    <div
      class="video-list-container"
      #videoListContainer
      [style.left.px]="videoListContainerLeftPosition()"
    >
      @if (videoCards().length > 0) {
        @for(video of videoCards(); track $index){
          <lsa-video-card (videoClick)="videoClick.emit($event)" [emitClick]="emitVideoClick()" [outlined]="video.id === selectedVideo()?.id" [video]="video"></lsa-video-card>
        }
      }@else if(playlistCards().length > 0) {
        @for(playlist of playlistCards(); track $index){
          <lsa-video-collage (click)="videoClick.emit(playlist)" [videos]="playlist.videos" [title]="videoTitlePrefix() + playlist.name"></lsa-video-collage>
        }
      }
  
      
    </div>
  
  </div>
  
  <button
    class="right-button"
    mat-fab
    aria-label="Next"
    (click)="scrollRight()"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</section>
